import React, { useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import {
  NamedLink,
  OutsideClickHandler,
  FieldTextInput
} from '../../components';

import { categoryOptions } from '../../filtersOptions';

import css from './SectionHero.module.css';

const SectionHero = props => {
  const { rootClassName, className, intl, currentUser, providerType } = props;

  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedKeywords, setSelectedKeywords] = useState(null);
  const [searchType, setsearchType] = useState("company");

  const classes = classNames(rootClassName || css.root, className);
  const isStartup = providerType === 'startup';

  const categoryMenu = (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div
        className={css.heroCategoriesHolder}
      >
        <button
          className={classNames(
            css.heroCategoriesBtn,
            { [css.heroCategoriesBtnPlaceholder]: !selectedCategory?.label },
          )}
          onClick={() => setIsOpen(true)}
        >
          {selectedCategory?.label || "Select category"}
        </button>
        {isOpen && (
          <ul className={css.heroCategoriesMenuContent}>
            {categoryOptions.map(item => {
              return (
                <li key={item.key} onClick={() => setIsOpen(false)}>
                  <div className={css.heroCategoriesMenuItem} onClick={() => setSelectedCategory({ label: item.label, key: item.key })}>
                    {item.label}
                  </div>
                </li>
              )
            })}
          </ul>
        )}
      </div>
    </OutsideClickHandler>
  );

  const keywordField = (
    <input
      className={css.field}
      type="text"
      id='keywords'
      name="keywords"
      placeholder={intl.formatMessage({ id: 'SectionHero.keywordsPlaceholder' })}
      onChange={(e) => setSelectedKeywords(e.target.value.toLowerCase())}
    />
  );

  let searchLinkUrl = '';
  const isOfferSearch = searchType == "offer";

  if (!!selectedCategory?.key) {
    if (isOfferSearch) {
      searchLinkUrl = searchLinkUrl + `pub_listingType=offer&pub_isOffer=true&pub_category=has_any:${selectedCategory?.key}&`;
    } else {
      searchLinkUrl = searchLinkUrl + `pub_listingType=provider&pub_providerType=${providerType}&pub_category=has_any:${selectedCategory?.key}&`
    };
  }

  if (!!selectedKeywords) {
    if (isOfferSearch) {
      searchLinkUrl = searchLinkUrl + `pub_listingType=offer&pub_isOffer=true&pub_keywords=has_any:${selectedKeywords}&`;
    } else {
      searchLinkUrl = searchLinkUrl + `pub_listingType=provider&pub_providerType=${providerType}&pub_keywords=has_any:${selectedKeywords}&`;
    };
  }

  if (!selectedKeywords && !selectedCategory?.key) {
    if (isOfferSearch) {
      searchLinkUrl = `pub_listingType=offer&pub_isOffer=true`
    } else {
      searchLinkUrl = `pub_listingType=provider&pub_providerType=${providerType}`;
    }
  };

  const titleEnding = isOfferSearch
    ? "Products"
    : isStartup ? "Startups" : "Companies"

  return (
    <div className={classes}>
      <div className={css.heroContent}>

        <h1 className={css.heroMainTitle} key={`${providerType}-title`}>
          <FormattedMessage id="SectionHero.title" values={{ type: titleEnding }} />
        </h1>

        <div className={css.switch}>
          <div
            className={isOfferSearch ? css.switchItem : css.switchItemSelected}
            onClick={() => setsearchType('company')}
          >
            Companies
          </div>
          <div
            className={isOfferSearch ? css.switchItemSelected : css.switchItem}
            onClick={() => setsearchType('offer')}
          >
            Products
          </div>
        </div>

        <div className={css.heroSearch}>

          <div className={css.heroKeywords}>
            {/* <label htmlFor="keywords">
              <FormattedMessage id="SectionHero.keywordsLabel" />
            </label> */}
            {keywordField}
          </div>

          {<div className={css.heroCategories}>
            {/* <label htmlFor="category">
              <FormattedMessage id="SectionHero.categoryLabel" />
            </label> */}
            {categoryMenu}
          </div>}

          <NamedLink
            className={css.heroButton}
            // name={currentUser ? "SearchPage" : "SignupPage"}
            name="SearchPage"
            to={{
              search: searchLinkUrl,
            }}
          >
            <FormattedMessage id="SectionHero.search" />
          </NamedLink>
        </div>
      </div>
    </div>
  );
};

SectionHero.defaultProps = { rootClassName: null, className: null };

SectionHero.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionHero;
